import React from 'react';

const BusinessFromTwo = () => {
  return (
    <section className="business-from-two mb-5" id="about">
      <div className="business-from-two-img">
        <img src="https://images.pexels.com/photos/16679219/pexels-photo-16679219.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1" alt="A group of people collaborating." width="913" height="247" style={{ width: '913px', height: '247px', objectFit: 'cover', display: 'block' }} />
      </div>
      <div className="business-from-two-bg-box">
        <div className="business-from-two-bg" data-jarallax data-speed="0.2" data-img-position="50% 0%"
          style={{ backgroundImage: "url(https://images.pexels.com/photos/32605202/pexels-photo-32605202.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1)", backgroundSize: "cover", backgroundPosition: "top", backgroundRepeat: "no-repeat", backgroundAttachment: "fixed" }}></div>
      </div>
      <div className="container">
        <div className="section-title text-left">
          <div className="section-title__tagline-box">
            <span className="section-title__tagline">About C2</span>
            <div className="section-title-shape">
              <img src="assets/images/shapes/section-title-shape.png" alt="decorative shape" />
            </div>
          </div>
          <h2 className="section-title__title">Welcome to <br /> Create & Commune</h2>
        </div>
        <div className="business-from-two__content-box">
          <p style={{ color: 'white' }}>Create & Commune (C2) is a vibrant ecosystem for creatives of all kinds—musicians, filmmakers, photographers, writers, performers, and more—to connect, grow, and create together. We are a community dedicated to nurturing talent, encouraging collaboration, and showcasing the limitless potential of the creative mind across Africa and the world.</p>
        </div>
      </div>
    </section>
  );
};

export default BusinessFromTwo;
